import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Input } from '@bingads-webui-react/primitive-validation';

export function InputWithAutoComplete(props) {
  const {
    dropdownOptions,
    className,
    validationProps,
    onSeleteChange,
    letterTriggerCount,
  } = props;

  const {
    onValidate,
    field,
    data,
    i18n,
    schema,
    alwaysShowError,
  } = validationProps || {};

  const [key, setKey] = React.useState(0);
  const [inputValue, setInputValue] = useState(data[field] ? data[field] : '');

  const onAutoCompleteValidate = (inputProps) => {
    // do some string validation
    if (_.isFunction(onValidate)) {
      onValidate(inputProps);
    }

    // get the choosed option
    const { data: newInputValue } = inputProps || {};
    const choosedOption = _.find(dropdownOptions, option => option.displayText === newInputValue[field]);

    if (!_.isObject(choosedOption)) {
      // if the input value in not one of the option
      setInputValue(newInputValue[field]);
    } else if (_.isFunction(onSeleteChange) && inputValue !== choosedOption.value.email) {
      // if the input value in one of the option
      onSeleteChange(choosedOption.value);
      setInputValue(choosedOption.value.email);
    } else {
      // if the input value is already be setted, need to setKey() to trigger reRender for input
      onSeleteChange(choosedOption.value);
      setKey(preKey => preKey + 1);
    }
  };

  return (
    <div>
      <Input
        key={key}
        className={className}
        list={letterTriggerCount <= inputValue.length ? 'options-list' : ''}
        validationProps={{
          onValidate: onAutoCompleteValidate,
          field,
          data: { [field]: inputValue },
          i18n,
          schema,
          alwaysShowError,
        }}
      />
      <datalist id="options-list">
        {_.map(dropdownOptions, (option, id) => <option key={id} value={option.displayText} />)}
      </datalist>
    </div>
  );
}

InputWithAutoComplete.propTypes = {
  dropdownOptions: PropTypes.arrayOf(PropTypes.shape({
    displayText: PropTypes.string,
    value: PropTypes.objectOf(PropTypes.any),
  })),
  className: PropTypes.string,
  validationProps: PropTypes.objectOf(PropTypes.any).isRequired,
  onSeleteChange: PropTypes.func,
  letterTriggerCount: PropTypes.number,
};

InputWithAutoComplete.defaultProps = {
  dropdownOptions: [],
  className: '',
  onSeleteChange: null,
  letterTriggerCount: 0,
};
